import React from "react";
import Card from "components/Card/Card";
import { useForm, SubmitHandler } from "react-hook-form";
import Page from "components/Page/Page";
import Button from "components/Button/Regular";
import Input from "components/Input/Input";
import Text from "components/Input/Text";
import { useAuth0 } from "@auth0/auth0-react";
import { useNavigate } from "react-router-dom";
import { useActiveOrg } from "context/ActiveOrgContext";
import { createOrgService } from "services/org-services.service";
import vgToast from "utils/toast";

type FormValues = {
  name: string;
  description: string;
};

const NewService = () => {
  const navigate = useNavigate();
  const { getAccessTokenSilently } = useAuth0();
  const { orgId } = useActiveOrg();
  const [submitting, setSubmitting] = React.useState(false);

  const {
    register,
    handleSubmit,
  } = useForm<FormValues>();

  const onSubmit: SubmitHandler<FormValues> = async (data) => {
    if (orgId <= 0) {
      vgToast.error("Select an active clinic before creating a service.");
      return;
    }
    setSubmitting(true);
    try {
      const token = await getAccessTokenSilently();
      const { data: res, error } = await createOrgService(token, {
        orgId,
        name: data.name,
        description: data.description,
      });
      if (error) {
        vgToast.error(error.message);
        return;
      }
      const newId =
        (res as { newRecordID?: number; NewRecordID?: number })?.newRecordID ??
        (res as { newRecordID?: number; NewRecordID?: number })?.NewRecordID;
      if (newId != null && Number.isFinite(Number(newId))) {
        navigate(`/app/services/${newId}`);
      } else {
        navigate("/app/services");
      }
    } catch (e) {
      vgToast.error((e as Error).message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Page>
      <Card
        title="Add New Service"
        subTitle="Fill the Following Details"
        className="mt-6"
      >
        <form onSubmit={handleSubmit(onSubmit)} className="p-10">
          <div className="flex flex-col gap-y-10 mb-10">
            <Input
              {...register("name")}
              label="Service Name"
              placeholder="Enter Service Name"
            />

            <Text
              {...register("description")}
              label="Service Description"
              placeholder="Enter Service Description"
            />
          </div>

          <Button color="Primary" type="submit" disabled={submitting}>
            <span>{submitting ? "Creating…" : "Create Service"}</span>
          </Button>
        </form>
      </Card>
    </Page>
  );
};

export default NewService;
